import { Search2LineIcon, Text } from 'ui';
import { SearchItemRow } from '../search-item-row';

const NoResultsItem = () => (
  <SearchItemRow icon={<Search2LineIcon size="small" />}>
    <Text>No results found</Text>
  </SearchItemRow>
);

export default NoResultsItem;
